import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptBill: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconReceiptBill"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V22.4982L16.7344 20.259L14.3333 22.3171L12 20.3171L9.66667 22.3171L7.26556 20.259L4 22.4982V2ZM8 7H16V9H8V7ZM8 11H12V13H8V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReceiptBill;
